var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-skeleton",attrs:{"aria-hidden":"true"}},_vm._l((_vm.lines),function(line){return _c('span',{key:line,staticClass:"text-skeleton__line",class:{ 'text-skeleton__line--last': line === _vm.lines }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }